import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class ContentSourceDocument extends BaseEntityModel {
  id?: number;
  contentSourceId?: number;
  name?: string;
  url?: string;
  path?: string;
  ocrPath?: string;

  constructor(model: Partial<ContentSourceDocument> = {}) {
    super(model);

    this.id = model.id;
    this.contentSourceId = model.contentSourceId;
    this.name = model.name;
    this.url = model.url;
    this.path = model.path;
    this.ocrPath = model.ocrPath;
  }
}
